import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

/**
 * "ما هو الفصل الافتراضي؟" — heading + intro + four white feature cards with
 * the design's emoji tiles (🗓️ 📝 📈 🎥). Static marketing content (i18n copy).
 */
const FeatureStrip: React.FC = () => {
	const [t] = useTranslation('landingPage', { keyPrefix: 'feature_strip' })
	const items = [
		{
			emoji: '🗓️',
			title: t('schedules_t', { defaultValue: 'جداول أسبوعية منظمة' }),
			desc: t('schedules_d', { defaultValue: 'محتوى مقسّم أسابيع وشهور يتابع خطة السنتر.' }),
		},
		{
			emoji: '📝',
			title: t('exams_t', { defaultValue: 'اختبارات إلكترونية' }),
			desc: t('exams_d', { defaultValue: 'اختبارات دورية بتصحيح فوري ودرجات واضحة.' }),
		},
		{
			emoji: '📈',
			title: t('followup_t', { defaultValue: 'متابعة مستمرة' }),
			desc: t('followup_d', { defaultValue: 'حضورك ودرجاتك ووقت تعلمك — كله مرئي لك ولولي أمرك.' }),
		},
		{
			emoji: '🎥',
			title: t('recorded_t', { defaultValue: 'حصص مسجلة ولايف' }),
			desc: t('recorded_d', { defaultValue: 'شاهد في أي وقت، أو احضر الندوات المباشرة.' }),
		},
	]
	return (
		<Section>
			<Heading>{t('heading', { defaultValue: 'ما هو الفصل الافتراضي؟' })}</Heading>
			<Intro>{t('intro', { defaultValue: 'بيئة تعليمية كاملة تحاكي الفصل الحقيقي — حصص منظمة، متابعة، واختبارات دورية بالتفاعل المباشر.' })}</Intro>
			<CardsGrid>
				{items.map((it, i) => (
					<FeatureCard key={i}>
						<IconTile aria-hidden>{it.emoji}</IconTile>
						<CardTitle>{it.title}</CardTitle>
						<CardDesc>{it.desc}</CardDesc>
					</FeatureCard>
				))}
			</CardsGrid>
		</Section>
	)
}

export default FeatureStrip

const Section = styled.section`
	padding: 12px 16px;
	display: flex;
	flex-direction: column;
	gap: 12px;
	text-align: start;
`
const Heading = styled.h2`
	margin: 0;
	font: var(--fw-bold) var(--fs-body-lg) var(--font-sans);
	color: var(--text-primary);
	@media (min-width: 1024px) {
		font-size: 22px;
	}
`
const Intro = styled.p`
	margin: 0;
	font: var(--fw-regular) 13px/1.7 var(--font-sans);
	color: var(--text-secondary);
`
const CardsGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 8px;
	@media (min-width: 1024px) {
		grid-template-columns: repeat(4, minmax(0, 1fr));
	}
`
const FeatureCard = styled.div`
	background: var(--surface-card);
	border: 1px solid var(--border);
	border-radius: var(--r-xl);
	padding: 14px;
	display: flex;
	flex-direction: column;
	gap: 8px;
`
const IconTile = styled.span`
	width: 36px;
	height: 36px;
	border-radius: var(--r-md);
	background: var(--blue-08);
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 18px;
	line-height: 1;
`
const CardTitle = styled.div`
	font: var(--fw-bold) 13px/1.5 var(--font-sans);
	color: var(--text-primary);
`
const CardDesc = styled.div`
	font: var(--fw-regular) var(--fs-micro-plus)/1.6 var(--font-sans);
	color: var(--text-secondary);
`
